// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1zeJT","label":"Category_label__2gYns","content":"Category_content__vk0Pr","header":"Category_header__1dyHI","location":"Category_location__1wE3V"};